<template>
  <div v-if="!loading" class="row">
    <div class="medium-6 columns">
      <section>
        <h1 v-html="welcomePageData.pageHeadline" />
        <h2 v-html="welcomePageData.policeHeadline" />

        <base-button-link
          class="large-6"
          :secondary="true"
          :href="welcomePageData.policeLink.url"
          :target="welcomePageData.policeLink.target"
          v-html="welcomePageData.policeLink.text"
        />

        <h2 v-html="welcomePageData.bikeFrameNumberHeadline" />
        <p v-html="welcomePageData.bikeFrameNumberText" />
        <h2 v-html="welcomePageData.insuranceHeadline" />
        <p v-html="welcomePageData.insuranceText" />

        <router-link
          class="button large large-6"
          to="/opret-cykel-skade/what"
          tag="button"
          data-test-bike-theft-claim-flow-link-button-start
        >
          <span v-html="welcomePageData.startClaimButtonText" />
        </router-link>

        <div v-if="welcomePageData.showDevelopmentButtons">
          <router-link class="button" to="/opret-cykel-skade/what/bike">
            Step 2 (development only)
          </router-link>

          <router-link class="button" to="/opret-cykel-skade/what/bike/equipment">
            Step 3 (development only)
          </router-link>

          <router-link class="button" to="/opret-cykel-skade/what/bike/summary">
            Summary (development only)
          </router-link>

          <router-link class="button" to="/opret-cykel-skade/what/bike/summary/confirmation">
            Confirmation (development only)
          </router-link>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BaseButtonLink from '@/components/UI/BaseButtonLink.vue';

export default {
  name: 'SplashPage',
  components: {
    BaseButtonLink
  },
  props: {
    claimId: {
      type: String,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      files: []
    };
  },
  computed: mapState({
    loading: (state) => state.bikeTheftClaimFlow.loading,
    welcomePageData: (state) => state.bikeTheftClaimFlow.data.welcomePage
  })
};
</script>
